<template>
	<div>
		<Link v-if="!no_dashboard" :to="link" :target="content.availability.available || course.sales_page === '' ? '_self' : '_blank'" class="tw-flex tw-p-4 tw-rounded-lg tw-text-gray-600 tw-cursor-pointer tw-font-semibold tw-mb-1 hover:tw-bg-blue-0" :class="{'tw-bg-gray-0 active-lesson': active}">
			<i v-if="content.availability.available" class="lesson-progress far fa-circle tw-text-gray-300 tw-text-2xl tw-mr-2 tw-rounded-full" :class="[{'finished': content.seen}, {'active': active}]"></i>
			<i v-else class="lesson-progress far fa-lock tw-text-gray-300 tw-text-2xl tw-mr-2 mimic-title">
				<span v-if="unlocksAt !== null">{{ $t('membership.unlocks_at') }} {{ unlocksAt }}</span>
			</i>
			<i class="lesson-type" :class="icon"></i>
			<h4 class="tw-leading-normal tw-truncate">
				<template v-if="course.numbered">
					{{ chapters_structure[index].chapter }}.{{ lesson_index + 1 }}
				</template>
				{{ content.name }}
			</h4>
		</Link>
		<Link v-else-if="display_content_without_module" class="tw-flex tw-p-4 tw-rounded-lg tw-text-gray-600 tw-cursor-pointer tw-font-semibold tw-mb-1 hover:tw-bg-blue-0" :to="moduleLink" :class="{'tw-bg-gray-0 active-lesson': active}">
			<i v-if="module.available" class="lesson-progress far fa-circle tw-text-gray-300 tw-text-2xl tw-mr-2 tw-rounded-full" :class="[{'finished': content.seen}, {'active': active}]"></i>
			<i v-else class="lesson-progress far fa-lock tw-text-gray-300 tw-text-2xl tw-mr-2 mimic-title">
				<span v-if="module.available_from !== null">{{ $t('membership.unlocks_at') }} {{ module.available_from }}</span>
			</i>
			<i class="lesson-type" :class="icon"></i>
			<h4 class="tw-leading-normal tw-truncate">
				<template v-if="course.module_count > 1 && course.numbered">
					{{ chapters_structure[index].chapter }}.{{chapters_structure[index].lesson}}
				</template>
				{{ content.name }}
			</h4>
		</Link>
	</div>
</template>

<script>
	import Link from "../Link.vue";
	import { mapState } from "vuex";

	export default {
		name: 'SidebarLesson',

		components: {
			Link
		},

		props: {
			index: {
				required: true,
			},
			lesson_index: {},
			content: { // this lesson
				required: true,
			},
			module: {
				required: true,
			},
			course: {
				required: true,
			},
			chapters_structure: {
				required: true,
			},
			no_dashboard: {
				required: true,
			},
		},

		computed: {
			...mapState(['display_content_without_module']),

			link() {
				if (this.content.availability.available || (!this.content.availability.available && this.content.availability.available_from !== null)) {
					return {
						name: 'lessons.show',
						params: {
							course_slug: this.$route.params.course_slug,
							module_slug: this.module.slug,
							lesson_slug: this.content.slug,
						},
					};
				} else {
					if (this.module.sales_page !== '' && this.module.sales_page !== null) {
						return this.module.sales_page ?? '#';
					} else if (this.course.sales_page !== '' && this.course.sales_page !== null) {
						return this.course.sales_page ?? '#';
					}

					return '#';
				}
			},

			moduleLink() {
				if (!this.module.available) {
					if (this.course.sales_page !== '') {
						return this.course.sales_page;
					}

					return '#';
				}

				return {
					name: 'lessons.show',
					params: {
						course_slug: this.$route.params.course_slug,
						module_slug: this.module.slug,
						lesson_slug: this.content.slug,
					},
				};
			},

			icon() {
				switch (this.content.content_kind) {
					case 'quiz':
						return 'far fa-graduation-cap';

					case 'video':
						return 'far fa-play';

					case 'audio':
						return 'far fa-music';

					default:
						return 'far fa-book';
				}
			},

			active() {
				return this.$route.params.module_slug === this.module.slug && this.$route.params.lesson_slug === this.content.slug;
			},

            unlocksAt() {
                if (this.content.availability.available_from === null) {
                    return null;
                }

                return moment(this.content.availability.available_from).format("DD-MM-YYYY HH:mm");
            },
		},
	};
</script>

<style lang="scss" scoped>
	.lesson-progress {
		height: 21px;

		&.active {
			@apply tw-text-green-500 tw-bg-green-500;

			&:after {
				@apply tw-text-white;
			}
		}
	}

	.lesson-type {
		@apply tw-pr-1 tw-flex tw-items-center tw-justify-center;
		padding-top: 1px;
		width: 21px;
		height: 21px;
	}
</style>
